module.exports = __webpack_public_path__ + "img/4-3-ribbons-1.c53caacb.jpg";